import type { UseQueryResult } from 'react-query';
import type { ModelState } from '@hotjar/webapp/features/Heatmaps/ContinuousCaptureReport/Report/ReportTypes';

export const getReportState = (
  screenshotData: UseQueryResult<HeatmapAPI.GetScreenshotDataResponse, Error>,
  heatData: UseQueryResult<HeatmapAPI.GetHeatDataResponse<HeatmapDataType>, Error>,
  takeScreenshotData: UseQueryResult<HeatmapAPI.Response, Error>,
): ModelState => {
  if (screenshotData.isError || heatData.isError || takeScreenshotData.isError) {
    return 'FETCH_ERROR';
  }

  if (screenshotData.isLoading || heatData.isLoading || (screenshotData?.data && !heatData?.data)) {
    return 'FETCHING';
  }

  if (screenshotData.isSuccess && heatData.isSuccess && screenshotData.data && heatData.data) {
    return 'DATA_FETCHED';
  }

  return 'INIT';
};
